<template>
    <div id="ModalGrupoSignatario" class="modal fade in" style="z-index:10000" data-backdrop="false" role="dialog">
        <div class="modal-dialog modal-el">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-user-plus"></i> Grupo Signatário</p>
                    <button type="button" class="close" @click="closeModal()" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="card card-outline card-outline-tabs" :class="appLayout.card">
                        <div class="card-header p-0 border-bottom-0">
                            <div class="nav-tabs-custom" role="tabpanel">
                                <!-- Nav tabs -->
                                <ul class="nav nav-tabs" role="tablist">
                                    <li role="presentation" class="nav-item">
                                        <a @click="tab = 1" :class="{'active': tab == 1}" class="nav-link"
                                            href="#tabIndex" aria-controls="tabIndex" role="tab" data-toggle="tab"><i
                                                class="fa fa-users"></i> Grupo de Signatários</a>
                                    </li>
                                    <li role="presentation" class="nav-item">
                                        <a @click="tab = 2" :class="{'active': tab == 2}" class="nav-link"
                                            href="#tabForm" aria-controls="tabForm" role="tab" data-toggle="tab"><i
                                                class="fa fa-user-plus"></i> Novo Grupo</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="tab-content">
                                <div role="tabpanel" class="tab-pane" :class="{'active': tab == 1}" id="tabIndex">
                                    <index ref="listGrupos" @changeSelected="changeSelected" @edit="edit" @destroy="destroy"></index>
                                </div>
                                <div role="tabpanel" :class="{'active': tab == 2}" class="tab-pane" id="tabForm">
                                    <formulario @saveData="fetchData" ref="formulario"></formulario>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="float-left btn btn-default" @click="closeModal()"><i
                            class="fa fa-times"></i>
                        {{$t('words.close')}}</button>
                    <button type="button" v-show="tab == 1" :disabled="loading" @click="addGroup()"
                        class="btn btn-success"><i class="fa fa-plus"></i>
                        {{$t('words.add')}} Grupo <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import formulario from '../../../views/grupos-signatario/form.vue';
    import Index from '../../../views/grupos-signatario/index.vue';
    export default {
        components: {
            formulario,
            Index
        },
        props: ['request'],
        data() {
            return {
                tab: 1,
                loading: false,
                file: {},
                form: {
                    hasDocument: false,
                    assinatura_nome: null,
                    assinatura_email: null,
                    assinatura_documento: null,
                    assinatura_telefone: null,
                    assinatura_tipo: null,
                    token_tipo: 'E',
                    ordem: 1,
                },
                grupos: [],
                selected: null,
            }
        },
        watch: {
            tab(data) {
                if (data == 2) {
                    this.$refs.formulario.syncList();
                }
            }
        },
        methods: {
            fetchData() {
                this.$refs.listGrupos.fetchData();
                this.tab = 1;
                this.selected = null;
            },
            changeSelected(payload) {
                this.selected = payload
            },
            addGroup() {
                if (!this.selected) {
                    toastr({
                        title: 'Selecione um grupo para adicionar!',
                        icon: 'warning'
                    });
                    return;
                }
                this.closeModal();
                this.$emit('insert', this.selected);
            },
            edit(payload) {
                this.tab = 2;
                //alert(JSON.stringify(payload))
                setTimeout(() => {
                    this.$refs.formulario.request = payload;
                }, 300)
            },
            destroy(payload) {
                let valid = confirm(`Tem certeza que deseja remover o grupo ${payload.nome}?`);
                if (valid) {
                    this.loading = true;
                    this.$store.dispatch('destroyGroup', payload.id).then(response => {
                        toastr({
                            title: response.message,
                            icon: response.status
                        });
                        this.fetchData();
                    }).catch(error => {
                        toastr({
                            title: error.message,
                            icon: error.status
                        });
                    }).finally(() => {
                        this.loading = false;
                    })
                }
            },
            closeModal() {
                $('#ModalGrupoSignatario').modal('hide');
            },
            validateUser() {
                if (this.request.signatarios.findIndex(
                        x => x.assinatura_email == this.form.assinatura_email &&
                        x.assinatura_tipo == this.form.assinatura_tipo) > -1) {
                    toastr({
                        title: 'E-mail já adicionado para esse tipo de assinatura!',
                        icon: 'warning'
                    });
                    throw 'E-mail já adicionado';
                }
            },

        }
    }
</script>